var map = {
	"./skin1/btn_left@3x.png": "b951",
	"./skin2/btn_left@3x.png": "19de",
	"./skin3/btn_left@3x.png": "8c72",
	"./skin4/btn_left@3x.png": "4012",
	"./skin5/btn_left@3x.png": "1592",
	"./skin6/btn_left@3x.png": "6f71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9a27";